export var DocumentTemplateSourceType = /*#__PURE__*/ function(DocumentTemplateSourceType) {
    DocumentTemplateSourceType["Default"] = "DEFAULT";
    DocumentTemplateSourceType["SpaceTab"] = "SPACE";
    return DocumentTemplateSourceType;
}({});
